import { useState } from "react";

export function useBowlerStats() {
  const [bowlers, setBowlers] = useState({});

  // ---------------------------
  // INIT BOWLER
  // ---------------------------
  const initBowler = (player) => {
    if (!player?.player_id) return;

    setBowlers((prev) => ({
      ...prev,
      [player.player_id]: {
        player_id: player.player_id,
        name: player.name,
        overs: 0,
        balls: 0,
        runs: 0,
        wickets: 0,
      },
    }));
  };

  // ---------------------------
  // ADD BOWLING EVENT
  // ---------------------------
  const addBowlingEvent = ({
    bowlerId,
    runs,
    isLegal,
    isWicket,
  }) => {
    setBowlers((prev) => {
      const b = prev[bowlerId];
      if (!b) return prev;

      let balls = b.balls + (isLegal ? 1 : 0);
      let overs = b.overs;

      if (balls === 6) {
        overs += 1;
        balls = 0;
      }

      return {
        ...prev,
        [bowlerId]: {
          ...b,
          balls,
          overs,
          runs: b.runs + runs,
          wickets: isWicket ? b.wickets + 1 : b.wickets,
        },
      };
    });
  };

    const resetBowlers = () => {
    setBowlers({});
  };
  return {
    bowlers,
    initBowler,
    addBowlingEvent,
    resetBowlers,
  };
}
